import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "@/components/Reveal";
import { FAQ_ITEMS } from "@/data/catalog";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="border-t border-[#1F1F1F] bg-[#050505] py-28 lg:py-40">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-[1fr_1.6fr] lg:gap-20 lg:px-10">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#E11D2E]">FAQ</p>
          <h2 className="mt-4 font-display text-3xl font-800 leading-tight tracking-tight text-white sm:text-4xl">
            Direct answers. No fine print.
          </h2>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#8A8A8A] md:text-base">
            Everything brands and artists ask before putting budget behind growth infrastructure.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="border-t border-[#1F1F1F]">
            {FAQ_ITEMS.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={item.q} className="border-b border-[#1F1F1F]" data-testid={`faq-item-${i}`}>
                  <button
                    data-testid={`faq-trigger-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="group flex w-full items-center justify-between gap-6 py-6 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className={`text-base font-600 transition-colors duration-300 md:text-lg ${isOpen ? "text-[#E11D2E]" : "text-white group-hover:text-[#E11D2E]"}`}>
                      {item.q}
                    </span>
                    <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.3 }}>
                      <Plus size={18} className={isOpen ? "text-[#E11D2E]" : "text-[#8A8A8A]"} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p data-testid={`faq-answer-${i}`} className="max-w-2xl pb-6 text-sm leading-relaxed text-[#8A8A8A] md:text-base">
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
